import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { container } from '@/app/container';
import { SalesRepositoryToken } from '../../di/tokens';
import type { ListTransactionsInput } from '../../data/datasources/sales-api.datasource';

type QueryFilters = Omit<ListTransactionsInput, 'page' | 'perPage'>;

/**
 * Lista paginada de transações (página de Vendas). A ordem vem junto com os
 * filtros (`sortBy`/`sortDirection`); sem ela, o back ordena por `occurredAt`
 * desc — o instante no gateway. `filters` vai como query param — o servidor filtra e devolve o `total` já
 * filtrado, então a paginação é sobre o conjunto certo. Os filtros entram na
 * `queryKey` para cada combinação ter seu próprio cache.
 */
export function useTransactions(
  page = 1,
  perPage = 10,
  filters: QueryFilters = {},
  options?: { enabled?: boolean },
) {
  const repository = container.resolve(SalesRepositoryToken);
  return useQuery({
    queryKey: ['sales', 'transactions', page, perPage, filters],
    queryFn: () => repository.listTransactions({ page, perPage, ...filters }),
    staleTime: 1000 * 60 * 5,
    placeholderData: keepPreviousData,
    enabled: options?.enabled ?? true,
  });
}
